import angular from 'angular';
import subcontractDetailsComponent from './subcontract-details.component';

let subcontractDetailsModule = angular.module('subcontractDetails', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('subcontractDetails', subcontractDetailsComponent);

export default subcontractDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontract-details/subcontract-details.js